// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'timeentries'

/**
 * TimeEntry Model Interface (auto-generated from Drizzle schema)
 */
export interface TimeEntryModel {
  id: string
  orgId: string
  workspaceId?: string
  userId: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  taskId: string
  startAt: string
  endAt?: string
  duration?: number
  categoryId?: string
  tagIds?: string[]
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "taskId": {
          "type": "string",
          "maxLength": 100
      },
      "startAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "endAt": {
          "type": "string",
          "maxLength": 200
      },
      "duration": {
          "type": "number",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 1
      },
      "categoryId": {
          "type": "string",
          "maxLength": 100
      },
      "tagIds": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "taskId",
      "startAt",
      "archived",
      "userId"
  ],
  indexes: [
      [
          "orgId",
          "taskId"
      ],
      [
          "orgId",
          "userId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
